import { TextSmall } from '@/components/Texts';
import React from 'react';

const ExplanationFunction = () => {
  return (
    <>
      <TextSmall fontWeight={700}>(1) Explanation of the function</TextSmall>
      <TextSmall>
        {`You can obtain information about our company and the services we offer
        in particular Diment.io together with the associated subpages
        (hereinafter collectively: "websites"). When you visit our websites,
        personal data may be processed.`}
      </TextSmall>
    </>
  );
};

export default ExplanationFunction;
